export default __webpack_public_path__ + "static/ai-banner-41593e26dd3363ee9a68705bb1f60657.png";